import EyeIcon from "@uui/Eye";
import LockIcon from "@uui/Lock03";
import EditIcon from "@uui/Pencil01";
import UserIcon from "@uui/UserCircle";

import type { EntityAccessLevel } from "@app/common/types";
import { lightOrDark } from "@app/embedded/theme/utils";

const ICONS: { [k in EntityAccessLevel]: typeof EditIcon } = {
  owner: UserIcon,
  editor: EditIcon,
  viewer_full: EyeIcon,
  viewer_recap_only: EyeIcon,
  forbidden: LockIcon,
  no_access: LockIcon,
};

const AccessLevelIcon = ({
  accessLevel,
  disabled = false,
}: {
  accessLevel: EntityAccessLevel;
  disabled?: boolean;
}) => {
  const Icon = ICONS[accessLevel];
  return (
    <Icon
      sx={{
        width: "18px",
        height: "18px",
        color: (theme) =>
          disabled
            ? lightOrDark("shades.neutral.300", "shades.neutral.500")(theme)
            : lightOrDark("shades.neutral.500", "shades.neutral.400")(theme),
      }}
    />
  );
};

export default AccessLevelIcon;
